import Splide from '@splidejs/splide';
//import "./modules/resizeWindowHeight";

document.addEventListener( 'DOMContentLoaded', () => {

const splideCustom = document.querySelectorAll('.splideCustom')

  if(!!splideCustom && splideCustom.length > 0){
    splideCustom.forEach(splideCustom => {
      // Grab the slide interval and convert it to an integer and milliseconds
      const interval = parseInt(splideCustom.dataset.interval) * 1000 || 3000

      new Splide(splideCustom, { pagination: false, perMove: 1,  pauseOnHover: false, interval: interval,
        // perPage: 2,
        height: 'auto',
        gap    : '2rem',
        // padding: '5rem',
          breakpoints: {
            6000: {
      
              fixedWidth: '620px',
              gap    : '2rem',
              //padding: '5rem',
            },
        
            2000: {
              fixedWidth: '620px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            1200: {
              fixedWidth: '520px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            960: {
              fixedWidth: '520px',
              gap    : '.7rem',
              //padding: '0.1rem',
              
            },
            820: {
              perPage: 1,
              fixedWidth: '100%',
              gap    : '1.2rem',
              //padding: '0.2rem',
        
              //gap    : '8rem',
        
            }
          },
        
        
              }).mount()

    })
  }
  
  // Splide
  const splidePosts = document.querySelectorAll('.splidePosts')

  if(!!splidePosts && splidePosts.length > 0){
    splidePosts.forEach(splidePosts => {

      // Grab the slide interval and convert it to an integer and milliseconds
      const interval = parseInt(splidePosts.dataset.interval) * 1000 || 3000
      new Splide(splidePosts, { pagination: false, perMove: 1, fixedHeight:'650px', pauseOnHover: false, interval: interval,
// marginLeft:'2em',
// gap    : '2rem',
  breakpoints: {
    6000: {
      perPage: 2,
      gap    : '2rem',
      fixedHeight:'750px',

    },

    2000: {
      perPage: 2,
      gap    : '2rem',

      height:'650px',
    },

    1200: {
      perPage: 1,
      gap    : '2rem',

      fixedHeight:'650px',
    },

    960: {
      perPage: 1,
      gap    : '.7rem',
      fixedHeight:'650px',

    },
    720: {
      perPage: 1,
      fixedHeight:'500px',
      gap    : '0.7rem',


      //gap    : '8rem',

    }
  },


      }).mount()
    })
  }

  // Splide
  const splideCard = document.querySelectorAll(['.splideCard'])

  if(!!splideCard && splideCard.length > 0){
    splideCard.forEach(splideCard => {
      // Grab the slide interval and convert it to an integer and milliseconds
      const interval = parseInt(splideCard.dataset.interval) * 1000 || 3000

      new Splide(splideCard, { pagination: false, perMove: 1, fixedWidth: '420px', fixedHeight: '500px', pauseOnHover: false, interval: interval,
        // perPage: 2,
        height: 'auto',
        gap    : '2rem',
        // padding: '5rem',
          breakpoints: {
            6000: {
              fixedWidth: '420px', fixedHeight: '500px',
              gap    : '2rem',
              //padding: '5rem',
            },
        
            2000: {
              fixedWidth: '420px', fixedHeight: '500px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            1200: {
              fixedWidth: '420px', fixedHeight: '500px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            960: {
              fixedWidth: '400px', fixedHeight: '500px',
              gap    : '.7rem',
              //padding: '0.1rem',
              
            },
            400: {
              fixedWidth: '100%', fixedHeight: '500px',
              gap    : '1.2rem',
              //padding: '0.2rem',
        
              //gap    : '8rem',
        
            }
          },
        
        
              }).mount()

    })
  }

    // Splide
  const splideProducts = document.querySelectorAll('.splideProducts')

  if(!!splideProducts && splideProducts.length > 0){
    splideProducts.forEach(splideProducts => {

      // Grab the slide interval and convert it to an integer and milliseconds
      const interval = parseInt(splideProducts.dataset.interval) * 1000 || 3000
      new Splide(splideProducts, { pagination: false, perMove: 1, fixedWidth: '420px', pauseOnHover: false, interval: interval,
        // perPage: 2,
        height: 'auto',
        gap    : '2rem',
        // padding: '5rem',
          breakpoints: {
            6000: {
              fixedWidth: '420px',
              gap    : '2rem',
              //padding: '5rem',
            },
        
            2000: {
              fixedWidth: '420px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            1200: {
              fixedWidth: '420px',
              gap    : '2rem',
              //padding: '5rem',
          
            },
        
            960: {
              fixedWidth: '400px', 
              gap    : '.7rem',
              //padding: '0.1rem',
              
            },
                700: {
              fixedWidth: '70%', 
              gap    : '1.2rem',
              //padding: '0.2rem',
        
              //gap    : '8rem',
        
            },

            400: {
              fixedWidth: '50%', 
              gap    : '1.2rem',
              //padding: '0.2rem',
        
              //gap    : '8rem',
        
            }
          },


      }).mount()
    })
  }
})
